import React from 'react';
import '../styles/About.css'; // Importing the CSS for styling

function About() {
  return (
    <div className="about-container">
      <h1 className="about-title">Christi's Blog</h1>
      <p className="about-content">
 Welcome! I’m Christi, and I’m glad you’ve found your way here.
This blog is a space where I share my journey of healing, growth, and the life experiences that continue to shape me.

Along the way, I’ve faced challenges that tested my resilience and moments that pushed me to rediscover who I am and what I value. These experiences have taught me that healing is never one-size-fits-all, and growth often emerges in surprising ways — whether through adversity, new passions, or unexpected opportunities.

Here you’ll find reflections on resilience, self-advocacy, and the lessons we can carry forward when life doesn’t go as planned. My hope is that this space serves as a source of encouragement, reflection, and dialogue — whether you’re navigating your own challenges or simply seeking inspiration on your personal journey.

Thank you for joining me as we walk this path of healing and growth together.
</p>

    </div>
  );
}

export default About;

